import { render } from "./Attribute.vue?vue&type=template&id=0c314956&lang=pug"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"

import "./Attribute.vue?vue&type=style&index=0&id=0c314956&lang=scss"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__